module.exports = __webpack_public_path__ + "img/57-3.214eb653.png";